import { INewbuildingLayoutOffer } from 'shared/types/newbuildingBookedOfferLayouts';

import { IState } from '../../store';

export const selectBookedOfferLayouts = (state: IState): INewbuildingLayoutOffer[] =>
  state.newbuildingBookedOfferLayouts;
